module.exports = __webpack_public_path__ + "img/niño74.bf033aa3.jpg";